import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import { fetchAllAverageReviews, recoverId, mergingDatas, mergingRecipeFromGraphqlCTFAndReviews } from '~/helpers/reviewsRating';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import RecipeCard from '~/components/Recipe/RecipeCard.vue';
export default defineComponent({
  name: 'BlockRecipeList',
  components: {
    RecipeCard: RecipeCard,
    NativeCarousel: NativeCarousel
  },
  props: {
    relatedRecipes: {
      type: Object,
      default: null
    }
  },
  setup: function setup(props) {
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var listOfRecipes = computed(function () {
      var _props$relatedRecipes;
      return (_props$relatedRecipes = props.relatedRecipes) === null || _props$relatedRecipes === void 0 ? void 0 : _props$relatedRecipes.listOfRecipes;
    });
    var isSomeRecipeHasSlug = computed(function () {
      var _listOfRecipes$value;
      return ((_listOfRecipes$value = listOfRecipes.value) === null || _listOfRecipes$value === void 0 ? void 0 : _listOfRecipes$value.some(function (recipe) {
        var _recipe$fields;
        return (recipe === null || recipe === void 0 ? void 0 : (_recipe$fields = recipe.fields) === null || _recipe$fields === void 0 ? void 0 : _recipe$fields.slug) || (recipe === null || recipe === void 0 ? void 0 : recipe.slug);
      })) || false;
    });
    var description = computed(function () {
      var _props$relatedRecipes2;
      return (_props$relatedRecipes2 = props.relatedRecipes.description) === null || _props$relatedRecipes2 === void 0 ? void 0 : _props$relatedRecipes2.substring(0, 100);
    });
    var recipesReviews = useState('recipes-reviews', function () {
      return [];
    });
    var relatedRecipesTitle = computed(function () {
      return i18n.tc('related.recipes', recipesReviews.value.length);
    });
    /**
     * We use different merging method if we are RelatedRecipesFromCTFGraphQL or legacy RelatedRecipes
     */
    var mergeRecipeWithReviews = function mergeRecipeWithReviews() {
      var _listOfRecipes$value2, _listOfRecipes$value$;
      var reviews = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data;
      if (listOfRecipes.value === undefined || ((_listOfRecipes$value2 = listOfRecipes.value) === null || _listOfRecipes$value2 === void 0 ? void 0 : _listOfRecipes$value2.length) === 0) {
        return undefined;
      }
      if ((_listOfRecipes$value$ = listOfRecipes.value[0]) !== null && _listOfRecipes$value$ !== void 0 && _listOfRecipes$value$.slug) {
        data = mergingRecipeFromGraphqlCTFAndReviews(listOfRecipes.value, reviews);
      } else {
        data = mergingDatas(listOfRecipes.value, reviews);
      }
      recipesReviews.value = data;
    };
    useLazyAsyncData('recipe-with-reviews', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            mergeRecipeWithReviews();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchAllAverageReviews(recoverId(listOfRecipes.value));
          case 2:
            data = _context2.sent;
            mergeRecipeWithReviews(data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return {
      relatedRecipesTitle: relatedRecipesTitle,
      listOfRecipes: listOfRecipes,
      description: description,
      recipesReviews: recipesReviews,
      isSomeRecipeHasSlug: isSomeRecipeHasSlug
    };
  }
});